jQuery(function($) {

	// ヘッダー検索ボックス SP時クリック処理
	$('.header__search-button').on('click', function() {
		$(this).parents('.header').toggleClass('is-search-box-active');
	});

	// SPメニュー ハンバーガーアイコンクリック処理
	let state = false;
	let scrollPos;

	$('.header__toggle-button').on('click', function() {
		if (state == false) {
			scrollPos = $(window).scrollTop();
			$('body').addClass('is-menu-open').css({'top': -scrollPos});
			state = true;
		} else {
			$('body').removeClass('is-menu-open').css({'top': 0});
			window.scrollTo(0, scrollPos);
			state = false;
		}
	});
	$('.header__sp-nav-item a, .header__category-item:not(.has-child) > a, header__category-item.has-child.is-open > a, .header__sub-category-item a, .header__overlay').on('click', function() {
		$('body').removeClass('is-menu-open').css({'top': 0});
		window.scrollTo(0, scrollPos);
		state = false;
	});

	// カテゴリーリスト（SPメニュー/サイドバー） クリック処理
	const categoryDropdownParent = $('.js-category-item.has-child');
	const categoryDropdownLink = $('.js-category-item.has-child > a');
	categoryDropdownLink.on('click', function() {
		if (!$(this).parent(categoryDropdownParent).hasClass('is-open')) {
			$(this).parent(categoryDropdownParent).addClass('is-open');
			if ($(this).parent(categoryDropdownParent).hasClass('header__category-item')) {
				return false;
			}
		} else {
			$(this).parent(categoryDropdownParent).removeClass('is-open');
		}
	});

	// TOPへ戻るボタン アニメーション
	const pageTop = $('.page-top');
	function pageTopAnime() {
		const scrollTop = $(window).scrollTop(); 
		if (scrollTop >= 200) {
			pageTop.removeClass('is-down');
			pageTop.addClass('is-up');
		} else {
			if (pageTop.hasClass('is-up')) {
				pageTop.removeClass('is-up');
				pageTop.addClass('is-down');
			}
		}
	}
	pageTopAnime();

	// TOPへ戻るボタン クリック処理
	pageTop.on('click', function() {
		$('body, html').stop().animate({
			scrollTop: 0
		}, 500, 'swing');
		return false;
	});

	// 検索結果ページ 絞り込み検索 検索するボタンを<input>タグから<button>タグに変更
	const filterSearch_item = $('.filter-search__form li:nth-of-type(5)');
	filterSearch_item.append('<button type="submit" class="filter-search__submit-button button button--search">検索する</button>');

});